"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelMetrics = void 0;
const tslib_1 = require("tslib");
const __elasticsearch_1 = require("../../../../__elasticsearch");
const __enums_1 = require("../../../../__types/__enums");
function parseContentMetricElasticsearchResult(channels, results) {
    const buckets = results.aggregations.counters.buckets;
    const channelMetrics = channels.map((channel) => {
        const bucketDocument = buckets.find(doc => doc.key === channel._id);
        if (!bucketDocument) {
            return { contentId: channel._id, totalPosts: 0 };
        }
        return { contentId: bucketDocument.key, totalPosts: bucketDocument.doc_count };
    });
    return channelMetrics;
}
function getChannelMetrics(contents) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const channels = contents.filter(doc => doc.contentType === 'channel');
        if (channels.length === 0) {
            return [];
        }
        const channelQuery = {
            bool: {
                must: [
                    {
                        terms: {
                            rootContentId: channels.map(doc => doc._id)
                        }
                    },
                    {
                        term: {
                            contentType: {
                                value: 'channelCard'
                            }
                        }
                    }
                ],
                must_not: [
                    {
                        term: {
                            deleted: {
                                value: true
                            }
                        }
                    }
                ]
            }
        };
        const metricsQuery = {
            query: channelQuery,
            aggs: {
                counters: {
                    terms: {
                        field: 'rootContentId',
                        size: channels.length
                    }
                }
            }
        };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL);
        const elasticsearchResults = yield elasticsearchClient.search({
            index: __enums_1.ElasticsearchIndicesEnum.OFFERS,
            type: __enums_1.ElasticsearchTypesEnum.OFFER,
            size: 0,
            body: metricsQuery
        });
        return parseContentMetricElasticsearchResult(channels, elasticsearchResults);
    });
}
exports.getChannelMetrics = getChannelMetrics;
//# sourceMappingURL=getChannelMetrics.js.map